import Card from "react-bootstrap/Card";
import ProgressBar from "react-bootstrap/ProgressBar";

import {
  BsCheck
} from "react-icons/bs";

type ChargerProgressBarProps = {
  darkMode: boolean,
  progressBarValue: () => number
}

export default function ChargerProgressBar({darkMode, progressBarValue}: ChargerProgressBarProps) {

  return(
    <Card className={`p-4 table-responsive ${darkMode ? "bg-dark" : ""}`} style={{overflow: "visible"}}>
      <div>
        <ProgressBar now={progressBarValue()} className="mx-2"/>  
        <div className="d-flex justify-content-between" style={{marginTop: "-25px"}}>
          <div className="d-flex flex-column align-items-start">
            <div className="rounded-circle d-flex align-items-center justify-content-center" style={{width: "35px", height: "35px", backgroundColor: "white", border: "2px solid blue"}}>
              { progressBarValue() >= 3 &&
                <BsCheck style={{position: "absolute"}} size={30} color="blue"/>
              }
            </div>
            <p className={`d-none d-md-block ${darkMode ? "text-white" : "text-secondary"} mb-0`}>Installed</p>
          </div>
          <div className="d-flex flex-column align-items-center">
            <div className="rounded-circle d-flex align-items-center justify-content-center" style={{width: "35px", height: "35px", backgroundColor: "white", border: "2px solid blue"}}>
              { progressBarValue() >= 50 &&
                <BsCheck style={{position: "absolute"}} size={30} color="blue"/>
              }
            </div>
            <p className={`d-none d-md-block ${darkMode ? "text-white" : "text-secondary"} mb-0`}>Adopted</p>
          </div>
          <div className="d-flex flex-column align-items-end">
            <div className="rounded-circle d-flex align-items-center justify-content-center" style={{width: "35px", height: "35px", backgroundColor: "white", border: "2px solid blue"}}>
              { progressBarValue() >= 99 &&
                <BsCheck style={{position: "absolute"}} size={30} color="blue"/>
              }
            </div>
            <p className={`d-none d-md-block ${darkMode ? "text-white" : "text-secondary"} mb-0`}>Connected</p> 
          </div>
        </div>
      </div>
    </Card>
  );
}